<div class="custom-control custom-switch">
  <input type="checkbox" [disabled]="eventFinished" class="custom-control-input" [value]="printer.id"
    [checked]="checked"
    (change)="onCheckBoxChange(deviceUsersPriceList.deviceUser.id, printerCategory.productCategory.id, printer.id, deviceUsersPriceList.deviceUser.deviceUserType.id, $event)"
    id="bodyCheckbox{{printer.id}}-{{printerCategory.productCategory.id}}-{{deviceUsersPriceList.deviceUser.id}}">
  <label class="custom-control-label"
    for="bodyCheckbox{{printer.id}}-{{printerCategory.productCategory.id}}-{{deviceUsersPriceList.deviceUser.id}}">{{printer.name}}</label>
</div>
